import React, { useEffect, useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import Header from '../../components/home/Header/Header';
import Footer from '../../components/Footer/Footer';
import MobileAccessory from './MobileAccessory';



const MobileD = () => {



  React.useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 800,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);
  return (
    <div  className=" mt-[62px] md:mt-[62px]  overflow-x-hidden" >
        <Header   />
        <MobileAccessory  />
        <Footer   />
    </div>
  )
}

export default MobileD